var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"water-plant-container"},[_c('div',{staticClass:"showcase-area"},[_c('HeaderNav')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }